<template>
  <DelayHydration>
    <div class="main-wrapper">
      <Constructor :sections="constructorItems" />
    </div>
  </DelayHydration>
</template>
<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';
import getConstructorData from '~/components/constructor-components/getConstructorData';
import Constructor from '~/components/constructor-components/ConstructorComponents.vue';
import { base64ToObj, objToBase64 } from '~/utils/base64';

const globalStore = useGlobalStore();
const seoData = computed(() => globalStore.seoData);
const constructorItems = ref([]);

const dataConstructor = await useAsyncData('dataConstructor', async () => {
  const data = await getConstructorData('site/dashboard', false);
  return objToBase64({ data });
});
if (dataConstructor.data.value) {
  const data = base64ToObj(dataConstructor.data.value).data;
  if (data?.items) {
    constructorItems.value = data.items;
  }
}

useHead({
  meta: [
    {
      hid: 'keywords',
      name: 'keywords',
      content: `${seoData.value.page?.keywords}`
    }
  ]
});
useSeoMeta({
  title: `${seoData.value.page?.title}`,
  ogTitle: `${seoData.value.page?.title}`,
  description: `${seoData.value.page?.description}`,
  ogDescription: `${seoData.value.page?.description}`
});
onBeforeMount(() => {
  if (window && window?.location?.pathname === '/index/') {
    window.history.replaceState({}, '', '/');
  }
});
onMounted(() => {
  if (globalStore.isOpenAdultModal) globalStore.setOpenAdultModal(false);
  if (!import.meta.env.SSR && window?.dataLayer) {
    window.dataLayer.push({
      ecomm_pagetype: 'home'
    });
  }
});
</script>
<style></style>
